import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito equipo especial?',
    a: 'No, solo una superficie firme como el suelo o una alfombra.'
  }, {
    q: '¿Cuánto tiempo toma?',
    a: 'El protocolo base toma exactamente 8 minutos.'
  }, {
    q: '¿Es seguro si tengo una hernia?',
    a: 'Sí, el método se enfoca en quitar presión, que es exactamente lo que una hernia necesita.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí, un solo pago y acceso de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-cream" data-id="element-17">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-12 text-center" data-id="element-20">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-22">
              <div className="bg-white rounded-xl border border-cream-200 overflow-hidden shadow-sm transition-all hover:shadow-md" data-id="element-23">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-24">
                  <span className="font-semibold text-teal-900 text-lg" data-id="element-25">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-26">
                    <ChevronDown className="w-5 h-5 text-teal-600" data-id="element-27" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-28">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-29">
                      <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-30">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}